import axios, { post, put } from 'axios';

export const CarTypeList = (params) => async (dispatch) => {
  try {
    return await axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/car-types`, { params })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  } catch (error) {}
};

export const CreateCarType = (data) => async (dispatch) => {
  return await post(`${process.env.REACT_APP_BASE_URL}/api/car-types`, data)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((e) => {
      return Promise.reject(e);
    });
};

export const UpdateCarType = ({ id, data }) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      return await put(
        `${process.env.REACT_APP_BASE_URL}/api/car-types/${id}`,
        data,
        config
      )
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    } catch (error) {}
  };

export const DestroyCarType = (id) => async () => {
  return await axios
    .delete(`${process.env.REACT_APP_BASE_URL}/api/car-types/${id}`)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((e) => {
      return Promise.reject(e);
    });
};
